import React, { useState } from "react";
import { Button } from "../Button/Button";
import { useSelector } from "react-redux";
import { Container } from "./styled";
import Typography from "../Typography";
import { Link } from "react-router-dom";

export const CookieBanner = () => {
  const cookieAcceptKey = "cookieAccept";
  const isShowPlayer = useSelector((state) => !!state.player.currentEntity);

  const [isCookieAccepted, setCookieAccepted] = useState(
    () => localStorage.getItem(cookieAcceptKey) === "true",
  );

  if (isCookieAccepted) {
    return null;
  }

  return (
    <Container $isShowPlayer={isShowPlayer}>
      <div>
        <Typography>
          Продолжая использовать наш сайт, вы соглашаетесь на обработку файлов
          cookies.{" "}
          <Link to="/policy-privacy" target="_blank">
            Подробнее
          </Link>
        </Typography>
      </div>
      <Button
        onClick={() => {
          setCookieAccepted(true);
          localStorage.setItem(cookieAcceptKey, true);
        }}
        variant="orange"
      >
        Хорошо
      </Button>
    </Container>
  );
};
